import * as React from 'react';
import {connect} from 'react-redux';
import './footerbar.scss';

const spiLogo = require('../../../images/spi_logo_small.png');

export interface IFooterState {
    isOpen: boolean;
}

export class FooterImpl extends React.PureComponent<{}, IFooterState> {

    constructor(props: any) {
        super(props);
        this.state = {isOpen: false};
    }

    public render() {
        return <div className="footer-bar-container">
            <div className="spi-logo"><img src={spiLogo} height="40px" width="70px" alt="SPI"/></div>
           {/* <div className="footer-links">
                <span className="link">Privacy Policy</span>
                <span className="link">Contact us</span>
            </div>*/}
        </div>;
    }
}

export function mapStateToProps(state) {
    return {};
}

export const FooterBar = connect<{}, {}, {}>(mapStateToProps)(FooterImpl);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/Footer/index.tsx